import { Pipe, PipeTransform } from '@angular/core';
import { Group, Groups } from '../../services/user';
import { Role } from '../navigation';

@Pipe({
  name: 'userGroups'
})
export class UserGroupsPipe implements PipeTransform {

  transform(roles: Role[], groups: Group | Groups): Role[] {
    if (groups && groups.results) {
      return (roles || []).filter(role => (groups as Groups).results.some(group => group.Title === role.group));
    } else {
      return (roles || []).filter(role => (groups || {})[role.group]);
    }
  }

}
